import React from 'react';
import AppContainer from '../app-container';
import * as participantActions from '../../actions/participant';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import LocalizedStrings from '../../localization/strings';
import DocumentTitle from 'react-document-title';
import ParticipantResultHistoryForm from '../../components/participant/participant-result-history-form';
import Loading from '../../components/loading';
import ParticipantResultsDisplay from '../../components/participant-results-display';

class ParticipantResultsContainer extends AppContainer {

    constructor(props) {
        super(props);
        this.state = {
            searchParams: null
        };
    }

    executeSearch(params) {
        this.setState({
            searchParams: params
        });
        return this.props.actions.submitParticipantResultsSearch(params);
    }

    render() {
        const {participant_results} = this.props;
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.participantResultsHistory)}>

                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{LocalizedStrings.participantResultsHistory}</span>
                        </h1>
                        <ParticipantResultHistoryForm submit={this.executeSearch.bind(this)}/>
                        {this.props.participant_results.loading
                            ? <Loading/>
                            : <ParticipantResultsDisplay items={participant_results.items}
                                                         searchParams={this.state.searchParams}/>}
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}

export default connect(function (state) {
    return {participant_results: state.participant.participant_results};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...participantActions
        }, dispatch)
    };
})(ParticipantResultsContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/participant-results-page-container.js